import cn from "classnames"

import * as AdrDomain from "@/domain/adr"
import { useTranslation } from "@/hooks/useTranslation"
import { Fire } from "@/icons"
import { Step } from "./Step"
import { TitleStep } from "./TitleStep"
import { getThreatPrefix } from "./helpers"

import styles from "./NextStepsTabAdr.module.scss"

import type { Props } from "./NextStepsTabAdr.types"

export const ContainThreatStep = (props: Props) => {
  const { incident } = props
  const { t } = useTranslation("translation", {
    keyPrefix: `${getThreatPrefix(incident)}.nextSteps.threat${AdrDomain.isVM(incident) ? "_vm" : ""}`
  })

  if (incident.type === "EXPOSURE_TO_NEWLY_PUBLISHED_CVE") return null

  return (
    <div className={styles.wrapper}>
      <Fire className={cn(styles.icon, styles.iconFire)} />
      <TitleStep title={t("title")} description={t("description")} />
      <Step
        title={t("steps.isolatePod.title")}
        description={t("steps.isolatePod.description")}
        action={t("steps.isolatePod.action")}
      />
      <Step
        title={t("steps.restartPod.title")}
        description={t("steps.restartPod.description")}
        action={t("steps.restartPod.action")}
      />
    </div>
  )
}
